import { combineReducers } from "redux";
import {default as registerReducer} from "./containers/Register/Register.reducer"
import {default as waitingReducer} from "./containers/Waiting/Waiting.reducer"
import {default as acceptedReducer} from "./containers/Accepted/Accepted.reducer"
import {default as globalReducer} from "./containers/GlobalReduxState/reducer"

export default  combineReducers( {registerReducer,waitingReducer,acceptedReducer, globalReducer} );
